import styled from 'styled-components';
import { Dialog } from '@m/alchemy-ui/Dialog';
import { units } from '@m/alchemy-ui/theme';

export const Title = styled.h1`
  flex: 1;
  text-align: center;
`;

export const MedalliaSnappyLogo = styled.img`
  display: block;
  height: 42px;
  margin: 0 auto;
  width: 170px;
`;

export const ComfortableDialogBody = styled(Dialog.Body)`
  margin-top: ${units(3)};
  margin-bottom: ${units(1.5)};
`;

export const Description = styled.p`
  margin-top: ${units(1.5)};
  margin-bottom: ${units(2)};
`;

export const RightAlignedDialogFooter = styled(Dialog.Footer)`
  text-align: right;
`;
